"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var icons_1 = require("../../../icons");
var input_1 = require("../../input");
var constants_1 = require("../../input/Button/constants");
var SIZES = {
    small: {
        closeIcon: 20,
        btn: 28,
    },
    default: {
        closeIcon: 24,
        btn: 40,
    },
    large: {
        closeIcon: 28,
        btn: 44,
    },
};
var CloseButton = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'default' : _b, rest = __rest(_a, ["size"]);
    var sizes = SIZES[constants_1.SIZE_TO_INTERNAL_SIZE[size]];
    return (react_1.jsx(input_1.Button, __assign({}, rest, { size: size, variant: "flush", css: {
            display: 'inline-grid',
            placeItems: 'center',
            padding: 0,
            width: sizes.btn,
            height: sizes.btn,
        } }),
        react_1.jsx(icons_1.XClose, { size: sizes.closeIcon })));
};
exports.default = CloseButton;
